import apiError from './apiError.json'
import GridNavbar from './components/sections/GridNavbar/GridNavbar.json'
import OfflineButton from './components/sections/GridNavbar/OfflineButton.json'
import languages from './components/sections/Navbar/languages.json'
import settings from './components/sections/Navbar/settings.json'
import ProjectCard from './components/ui/Cards/ProjectCard.json'
import ClientDeleteDialog from './components/ui/Dialog/ClientDeleteDialog.json'
import DeleteFreelancer from './components/ui/Dialog/DeleteFreelancer.json'
import ProjectDeleteDialog from './components/ui/Dialog/ProjectDeleteDialog.json'
import QuoteDeleteDialog from './components/ui/Dialog/QuoteDeleteDialog.json'
import QuoteDuplicateDialog from './components/ui/Dialog/QuoteDuplicateDialog.json'
import QuoteMoveDialog from './components/ui/Dialog/QuoteMoveDialog.json'
import RemoveSupplierFromPrepConfirmDialog from './components/ui/Dialog/RemoveSupplierFromPrepConfirmDialog.json'
import MenuDrawer from './components/ui/Drawer/MenuDrawer.json'
import quoteGrid from './components/ui/Grid/quoteGrid.json'
import RecapQuoteGrid from './components/ui/Grid/RecapQuoteGrid.json'
import QuoteHeader from './components/ui/Header/QuoteHeader.json'
import RecapQuoteHeader from './components/ui/Header/RecapQuoteHeader.json'
import EditQuoteMenu from './components/ui/Menu/EditQuoteMenu.json'
import FilterMenu from './components/ui/Menu/FilterMenu.json'
import FilterNewPurchasePagesMenu from './components/ui/Menu/FilterNewPurchasePagesMenu.json'
import SmgMenu from './components/ui/Menu/SmgMenu.json'
import SortMenu from './components/ui/Menu/SortMenu.json'
import AddQuoteFormModal from './components/ui/Modals/AddQuoteFormModal.json'
import AddSecondaryQuoteModal from './components/ui/Modals/AddSecondaryQuoteModal.json'
import AiQuoteModal from './components/ui/Modals/AiQuoteModal.json'
import ClientFormModal from './components/ui/Modals/ClientFormModal.json'
import EditCo2EmissionSectionModal from './components/ui/Modals/EditCo2EmissionSectionModal.json'
import FreelancerModal from './components/ui/Modals/FreelancerModal.json'
import MergeQuoteModal from './components/ui/Modals/MergeQuoteModal.json'
import NewInvoiceModal from './components/ui/Modals/NewInvoiceModal.json'
import NewProposalsPOModal from './components/ui/Modals/NewProposalsPOModal.json'
import ProjectFormModal from './components/ui/Modals/ProjectFormModal.json'
import pricing from './components/ui/Modals/pricing.json'
import QuoteSummaryModal from './components/ui/Modals/QuoteSummaryModal.json'
import RecapQuoteSummaryModal from './components/ui/Modals/RecapQuoteSummaryModal.json'
import SubscriptionModals from './components/ui/Modals/SubscriptionModals.json'
import InvoicePdf from './components/ui/Pdf/InvoicePdf.json'
import ProjectPdf from './components/ui/Pdf/ProjectPdf.json'
import QuotePdf from './components/ui/Pdf/QuotePdf.json'
import RecapQuotePdf from './components/ui/Pdf/RecapQuotePdf.json'
import SearchBar from './components/ui/SearchBar/SearchBar.json'
import VersionUpdateToast from './components/ui/Toast/VersionUpdateToast.json'
import QuoteToolbar from './components/ui/Toolbar/QuoteToolbar.json'
import RecapQuoteToolbar from './components/ui/Toolbar/RecapQuoteToolbar.json'
import adminwalkthrough from './components/ui/Walkthrough/adminwalkthrough.json'
import errors from './pages/Auth/errors.json'
import forgotPassword from './pages/Auth/forgotPassword.json'
import login from './pages/Auth/login.json'
import newPassword from './pages/Auth/newPassword.json'
import signup from './pages/Auth/signup.json'
import archiveInvoices from './pages/archiveInvoices.json'
import banking from './pages/banking.json'
import billing from './pages/billing.json'
import clients from './pages/clients.json'
import clientTransaction from './pages/clientTransaction.json'
import companyTemplate from './pages/companyTemplate.json'
import contacts from './pages/contacts.json'
import dashboard from './pages/dashboard.json'
import exportInvoices from './pages/exportInvoices.json'
import freelancer from './pages/freelancer.json'
import invoices from './pages/invoices.json'
import Page404 from './pages/Page404.json'
import payments from './pages/payments.json'
import prepareInvoices from './pages/prepareInvoices.json'
import projectChildren from './pages/projectChildren.json'
import projectlist from './pages/projectlist.json'
import projects from './pages/projects.json'
import projectToolbar from './pages/projectToolbar.json'
import proposals from './pages/proposals.json'
import publicPage from './pages/publicPage.json'
import purchaseorders from './pages/purchaseorders.json'
import purchases from './pages/purchases.json'
import QuoteGridPage1 from './pages/QuoteGridPage1.json'
import quotelist from './pages/quotelist.json'
import reporting from './pages/reporting.json'
import reviewInvoices from './pages/reviewInvoices.json'
import supplierGantt from './pages/supplierGantt.json'
import suppliers from './pages/suppliers.json'
import supplierTransaction from './pages/supplierTransaction.json'
import teamsettings from './pages/teamsettings.json'
import upgradePlanRequired from './pages/upgradePlanRequired.json'
import CostLineNameFormatter from './utils/quoteGridUtils/CostLineNameFormatter.json'
import getPayrollTaxEnabledEditor from './utils/quoteGridUtils/getPayrollTaxEnabledEditor.json'
import getPayrollTaxTypesEditor from './utils/quoteGridUtils/getPayrollTaxTypesEditor.json'
import getUnitTypesEditor from './utils/quoteGridUtils/getUnitTypesEditor.json'
import OvertimeEditor from './utils/quoteGridUtils/OvertimeEditor.json'
import InvoiceDocumentEditor from './utils/recapGridUtils/InvoiceDocumentEditor.json'
import StatusCellEditor from './utils/recapGridUtils/StatusCellEditor.json'

const fr = {
	apiError,
	banking,
	billing,
	clients,
	contacts,
	dashboard,
	freelancer,
	Page404,
	invoices,
	prepareInvoices,
	reviewInvoices,
	exportInvoices,
	archiveInvoices,
	projects,
	projectToolbar,
	proposals,
	publicPage,
	purchaseorders,
	projectChildren,
	login,
	errors,
	forgotPassword,
	newPassword,
	signup,
	purchases,
	QuoteGridPage1,
	suppliers,
	reporting,
	payments,
	teamsettings,
	quotelist,
	projectlist,
	GridNavbar,
	OfflineButton,
	languages,
	settings,
	ProjectCard,
	ClientDeleteDialog,
	ProjectDeleteDialog,
	QuoteDeleteDialog,
	QuoteDuplicateDialog,
	DeleteFreelancer,
	QuoteMoveDialog,
	RemoveSupplierFromPrepConfirmDialog,
	MenuDrawer,
	quoteGrid,
	RecapQuoteGrid,
	QuoteHeader,
	RecapQuoteHeader,
	EditQuoteMenu,
	SmgMenu,
	SortMenu,
	FilterNewPurchasePagesMenu,
	FilterMenu,
	AiQuoteModal,
	AddQuoteFormModal,
	AddSecondaryQuoteModal,
	ClientFormModal,
	EditCo2EmissionSectionModal,
	FreelancerModal,
	MergeQuoteModal,
	NewInvoiceModal,
	ProjectFormModal,
	QuoteSummaryModal,
	RecapQuoteSummaryModal,
	SubscriptionModals,
	pricing,
	InvoicePdf,
	ProjectPdf,
	QuotePdf,
	RecapQuotePdf,
	SearchBar,
	QuoteToolbar,
	RecapQuoteToolbar,
	VersionUpdateToast,
	CostLineNameFormatter,
	getPayrollTaxEnabledEditor,
	getPayrollTaxTypesEditor,
	getUnitTypesEditor,
	OvertimeEditor,
	InvoiceDocumentEditor,
	StatusCellEditor,
	clientTransaction,
	companyTemplate,
	supplierGantt,
	supplierTransaction,
	upgradePlanRequired,
	NewProposalsPOModal,
	adminwalkthrough,
	translation: {},
} as const

export default fr
